import Cookies from 'js-cookie'

export function setCookie({ name, value, expiryDays }) {
  // TODO: Temporarily the domain name is driven from url. Have to be config driven
  Cookies.set(name, value, {
    expires: expiryDays,
    domain: location?.hostname,
    secure: true
  })
}

export function getCookie(name: string) {
  if (Cookies.get(name) === null || Cookies.get(name) === '' || Cookies.get(name) === undefined) {
    return null
  }
  return Cookies.get(name)
}

export function deleteCookie({ name }) {
  // TODO: Temporarily the domain name is driven from url. Have to be config driven
  Cookies.remove(name, { domain: location?.hostname, path: '/' })
}
